import React from 'react'
import { Container, PreloaderLine } from '@rst/ui-ts'
import { calcBlockHeight, formatText, usePreloaderFont } from '@rst/libs-ts'
import styled from 'styled-components'

export const LeadFormContactMobPreloader = (data: any) => {
	const descr = formatText(data.subtitle)
	const heightTitle = calcBlockHeight(
		data.title,
		usePreloaderFont(data),
		27,
		110,
		Math.min(window.innerWidth - 35, 755)
	)

	const heightCont = calcBlockHeight(
		'Контакты',
		usePreloaderFont(data),
		27,
		120,
		Math.min(window.innerWidth, 766)
	)
	const heightSubTitleCont1 = calcBlockHeight(
		'Для связи',
		usePreloaderFont(data),
		22,
		132,
		Math.min(window.innerWidth, 766)
	)
	const heightSubTitleCont2 = calcBlockHeight(
		'Время работы',
		usePreloaderFont(data),
		22,
		132,
		Math.min(window.innerWidth, 766)
	)
	const heightSubTitleCont3 = calcBlockHeight(
		'Адрес',
		usePreloaderFont(data),
		22,
		132,
		Math.min(window.innerWidth, 766)
	)
	const heightTime = calcBlockHeight(
		'пн—пт: 10:00—20:00',
		usePreloaderFont(data),
		16,
		150,
		Math.min(window.innerWidth, 766)
	)
	const heightAddress = calcBlockHeight(
		data.address,
		usePreloaderFont(data),
		16,
		150,
		Math.min(window.innerWidth, 766)
	)
	const heightEmail = calcBlockHeight(
		data.email,
		usePreloaderFont(data),
		16,
		150,
		Math.min(window.innerWidth, 766)
	)
	const heightPhone = calcBlockHeight(
		data.phone,
		usePreloaderFont(data),
		16,
		150,
		Math.min(window.innerWidth, 766)
	)
	return (
		<>
			<ContWrapp align={data.align}>
				<Cont
					heightCont={heightCont}
					heightSubTitleCont1={heightSubTitleCont1}
					heightSubTitleCont2={heightSubTitleCont2}
					heightSubTitleCont3={heightSubTitleCont3}
					heightTime={heightTime}
					heightPhone={heightPhone}
					heightEmail={heightEmail}
					heightAddress={heightAddress}
				>
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<PreloaderLine />
					<SocialBtns>
						<PreloaderLine />
						<PreloaderLine />
						<PreloaderLine />
					</SocialBtns>
				</Cont>
			</ContWrapp>
			<LeadWrapp align={data.align}>
				<Lead>
					<Header heightTitle={heightTitle}>
						<PreloaderLine />
						<Desc>
							{descr.map((x: { tag: string; text: any }, i: any) =>
								x.tag === 'ulArr' ? (
									<UlWrapp>
										{x.text.map((z: any) => (
											<PreloadUl {...data} {...z} />
										))}
									</UlWrapp>
								) : (
									<AnotherTag>
										<PreloadSubTitle {...data} {...x} key={i} />
									</AnotherTag>
								)
							)}
						</Desc>
					</Header>
					<Form>
						<TopForm>
							<PreloaderLine />
							<PreloaderLine />
						</TopForm>
						<TextArea>
							<PreloaderLine />
						</TextArea>
					</Form>
					<ButtonBlock>
						<PreloaderLine />
						<Info>
							<PreloaderLine />
							<PreloaderLine />
							<PreloaderLine />
						</Info>
					</ButtonBlock>
				</Lead>
			</LeadWrapp>
		</>
	)
}

const PreloadSubTitle = (data: any) => {
	const heightDescription = calcBlockHeight(
		data.text,
		usePreloaderFont(data),
		16,
		150,
		Math.min(window.innerWidth - 35, 755),
		data
	)

	return <PreloaderLine tag={data.tag} height={heightDescription} />
}

const PreloadUl = (data: any) => {
	const heightUl = calcBlockHeight(
		data.text,
		usePreloaderFont(data),
		16,
		150,
		Math.min(window.innerWidth - 35, 755),
		data
	)

	return <PreloaderLine tag={data.tag} height={heightUl} />
}

const Desc = styled.div`
	width: 100%;
	& > div {
		width: 100%;

		&:last-child {
			margin-bottom: 0;
		}
	}
`

const UlWrapp = styled.div`
	display: flex;
	flex-direction: column;
`

const AnotherTag = styled.div`
	margin-bottom: 0;
`

const StyledContainer = styled(Container)<{ align: string }>`
	display: flex;
	padding: 32px 16px;
	flex-direction: ${p => (p.align === 'left' ? 'column-reverse' : 'column')};
`

const LeadWrapp = styled.div<{ align: string }>`
	display: flex;
`

const ContWrapp = styled.div<{ align: string }>`
	display: flex;
`

const Lead = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	padding-bottom: 32px;
	width: 100%;
`

const SocialBtns = styled.div`
	display: flex;
	flex-direction: row;
	gap: 8px;
	margin-top: 14px;

	& > div {
		height: 40px;
		width: 40px;
		border-radius: 20px;
	}
`

const Cont = styled.div<{
	heightCont: number
	heightSubTitleCont1: number
	heightSubTitleCont2: number
	heightSubTitleCont3: number
	heightTime: number
	heightPhone: number
	heightAddress: number
	heightEmail: number
}>`
	display: flex;
	flex-direction: column;
	padding-top: 32px;
	width: 100%;

	& > div {
		&:nth-child(1) {
			height: ${p => `${p.heightCont}px`};
			width: 100%;
			margin-bottom: 24px;
		}
		&:nth-child(2) {
			height: ${p => `${p.heightSubTitleCont1}px`};
			width: 100%;
			margin-bottom: 8px;
		}
		&:nth-child(3) {
			height: ${p => `${p.heightPhone}px`};
			width: 100%;
			margin-bottom: 4px;
		}
		&:nth-child(4) {
			height: ${p => `${p.heightEmail}px`};
			width: 100%;
			margin-bottom: 16px;
		}
		&:nth-child(5) {
			height: ${p => `${p.heightSubTitleCont2}px`};
			width: 100%;
			margin-bottom: 4px;
		}
		&:nth-child(6) {
			height: ${p => `${p.heightTime}px`};
			width: 100%;
			margin-bottom: 8px;
		}
		&:nth-child(7) {
			height: ${p => `${p.heightTime}px`};
			width: 100%;
			margin-bottom: 16px;
		}
		&:nth-child(8) {
			height: ${p => `${p.heightSubTitleCont3}px`};
			width: 100%;
			margin-bottom: 8px;
		}
		&:nth-child(9) {
			height: ${p => `${p.heightAddress}px`};
			width: 100%;
			margin-bottom: 4px;
		}
	}
`

const Header = styled.div<{ heightTitle: number }>`
	gap: 10px;
	display: flex;
	flex-direction: column;

	& > div {
		&:nth-child(1) {
			height: ${p => `${p.heightTitle}px`};
			width: 100%;
		}
	}
`

const Form = styled.div`
	margin-top: 32px;
`

const TopForm = styled.div`
	gap: 8px;
	display: flex;
	flex-direction: column;
	& > div {
		width: 100%;
		height: 56px;
	}
`

const TextArea = styled.div`
	margin-top: 8px;
	margin-bottom: 11px;
	& > div {
		display: flex;
		height: 102px;
	}
`

const Info = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	min-height: 59px;
	& > div {
		height: 10px;

		&:nth-child(2) {
			width: 60%;
		}

		&:nth-child(3) {
			width: 75%;
		}
	}
`

const ButtonBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 7px;
	& > div {
		display: flex;
		width: 100%;

		&:nth-child(1) {
			height: 48px;
		}

		&:first-child {
			width: 100%;
		}
	}
`
